import React, { useState } from "react";
import { connect } from "react-redux";
import { Button, Modal } from "react-bootstrap";
import {
    setPopupRedmineActivity,
    RedminePost,
    updatedArrayFromRedminePopup
} from "../../redux/reduxActions/leadActions";
import TextareaAutosize from "react-autosize-textarea";
import {showToastError} from "../utils";

const RedminePopup = (props) => {
    const { selectedLead, isPopupRedmineOpened} = props;
    const [redmineLink, setRedmineLink] = useState('');
    const [animationDone, setAnimationDone] = useState(false);
    function closePopupRedmine() {
        props.setPopupRedmineActivity();
    }
    function RedmineAplly() {
        setAnimationDone(true);
        props.RedminePost(selectedLead.id, {redmine_link: redmineLink}).then(() => {
            const allListArray = props.leads.data;
        const indexArray = allListArray.findIndex((el) => el.id === selectedLead.id);
        // console.log(indexArray);
        const selectedArray = allListArray[indexArray];
        selectedArray.redmine_link = redmineLink;
        // console.log(selectedArray);
        const updatedAllArray = allListArray.map((item,index) => {
            if(index === indexArray) {
                let item = selectedArray;
                return item;
            }
            return item;
        })
        // console.log(updatedAllArray);
        props.updatedArrayFromRedminePopup(updatedAllArray);
            props.setPopupRedmineActivity();
            setAnimationDone(false);
        }).catch((error) => {
            setAnimationDone(false);
            showToastError('Error 424 from server ! Redmine_link field must have only URL link')
            console.log(error);
        });
    }
    return (
        <div>
            <Modal show={isPopupRedmineOpened} onHide={closePopupRedmine}>
                <div style={{ margin: 20 }}>
                    <div>
                        <p className="lead__title">
                            Redmine Link
                            <span style={{ color: 'red' }}>*</span>
                        </p>
                    </div>
                    <TextareaAutosize
                        onChange={(e) => setRedmineLink(e.target.value)}
                        className="lead__textarea lead__input"
                        rows={1}
                        style={{ width: '100%', marginTop: 20 }}
                        placeholder="..."
                    />
                </div>
                <Modal.Footer>
                        <Button
                            variant="secondary"
                            onClick={() => {
                                closePopupRedmine();
                            }}
                        >
                            Close
                        </Button>
                        <Button
                            variant="primary"
                            onClick={() => RedmineAplly()}
                            className="main-button-filled"
                        >
                            Save Link
                        </Button>
                </Modal.Footer>
            </Modal>
            {animationDone ? <div className="wrap"><div className="wrapLoader" /></div> : null}
        </div>
    );
};
export default connect((state) => ({
    leads: state.leadReducer.leads,
    selectedLead: state.leadReducer.selectedLead,
    isPopupRedmineOpened: state.leadReducer.isPopupRedmineOpened
}), {
    updatedArrayFromRedminePopup,
    setPopupRedmineActivity,
    RedminePost
})(RedminePopup);
